import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    width={10 * (props.wx ?? 1)}
    height={30 * (props.hx ?? 1)}
    viewBox="0 0 10 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <path
      d="M1.98152 20.2857C2.12654 19.6002 2.31487 19.1827 2.55326 18.7255C2.76901 18.3114 2.97006 17.9731 3.00264 17.4859C3.19891 14.5695 3.91886 9.47088 4.03766 5.3344C4.15248 1.32737 5.00394 0.540108 5.42669 0.578325C5.89513 0.620841 5.93764 2.37069 6.42635 5.04061C6.95081 7.90734 7.1761 9.48664 7.47607 11.5107C7.80982 13.7645 7.82214 14.9741 8.03669 16.455C8.15668 17.2824 8.24131 17.827 8.35097 18.2435C8.48368 18.747 8.56116 18.984 8.82657 19.5166C9.33871 20.5442 9.76146 25.0342 8.98907 26.3813C8.52063 27.1982 8.22741 27.5474 7.55077 27.7762C7.12444 27.92 6.18677 28.5606 5.47119 28.5764C4.79813 28.5917 4.24784 28.3366 3.28593 28.0022C2.63035 27.7743 2.26004 27.6214 1.79835 26.9096C1.03907 25.7383 1.56632 22.2467 1.98152 20.2862V20.2857Z"
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgNormal;
